import template from './managed_employees_help.html';
import * as Utils from '../../lib/savanna_utils.js';

class ManagedEmployeesHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class ManagedEmployeesHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new ManagedEmployeesHelpViewModel(this);
		this.bindings = bindings;
		const tr = Utils.get_translator('default');
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default {
	name: 'ManagedEmployeesHelp',
	dialog_class: ManagedEmployeesHelpPage,
	template: template,
	template_filename: 'translation/dialogs/managed_employees_help',
	provider: 'ps'
};
